// @flow
import {getViewPortSize} from '@pb/kit-util-get-view-port-size';

export const isElementInViewPort = (element: Element): boolean => {
    const rect = element.getBoundingClientRect();
    const {width, height} = getViewPortSize();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= height &&
        rect.right <= width
    );
};
